import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';
import { getUserMenu, loginReact } from '../utilities/api';
import '../pages/Login.css';

export const Login = () => {
    const navigate = useNavigate();
    const toast = useRef(null);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    // Role to route mapping
    const roleRoutes = {
        GSPOS: '/salesreports',
        MASTERS: '/salesreports',
        MANAGER: '/salesreports',
        CEO: '/salesreports'
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        if (!username || !password) {
            setError('Please enter username and password');
            return;
        }

        try {
            const response = await loginReact({ username, password });

            if (response.status === 'success') {
                const { user_id, username, branch, branch_id, client_id, role, base_url, token } = response;

                // Store in localStorage
                localStorage.setItem('userid', user_id);
                localStorage.setItem('username', username);
                localStorage.setItem('branch', branch);
                localStorage.setItem('branchid', branch_id);
                localStorage.setItem('clientid', client_id);
                localStorage.setItem('role', role);
                if (base_url) localStorage.setItem('base_url', base_url);
                // The backend uses this Bearer token (not the session cookie) to resolve
                // which client's database a request should hit — required cross-origin,
                // where the session cookie never reaches the API (see api.js interceptor).
                if (token) localStorage.setItem('token', token);

                toast.current.show({ severity: 'success', summary: 'Login Successful', detail: `Welcome ${username}`, life: 3000 });

                const normalizedRole = String(role || '').trim().toUpperCase();
                const fallbackPath = roleRoutes[normalizedRole] || '/salesreports';

                // Redirect to the first menu item returned by getUserMenu
                try {
                    const groups = await getUserMenu(user_id);
                    const firstTo = groups?.[0]?.items?.[0]?.to;
                    navigate(firstTo || fallbackPath);
                } catch (menuErr) {
                    // If menu fetch fails, fall back to role-based route
                    console.error('Menu fetch error (redirect fallback):', menuErr);
                    navigate(fallbackPath);
                }
            } else {
                setError(response.message || 'Invalid credentials');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError('Server error or invalid credentials');
        }
    };

    return (
        <div className="form-demo">
            <div className="flex justify-content-center">
                <div className="card">
                    <h5 className="login-title">Login</h5>
                    <Toast ref={toast} />
                    {error && <p style={{ color: 'red' }}>{error}</p>}

                    <form onSubmit={handleLogin} className="p-fluid">
                        <div className="field">
                            <span className="p-float-label p-input-icon-right">
                                <InputText placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                                <label htmlFor="username">Username*</label>
                            </span>
                        </div>

                        <div className="field">
                            <span className="p-float-label">
                                <Password placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} feedback={false} required />

                                <label htmlFor="password">Password*</label>
                            </span>
                        </div>

                        <Button type="submit" label="Login" className="mt-2" />
                    </form>
                </div>
            </div>
        </div>
    );
};
